<template>
    <LayoutsDownloadHeader />

    <UMain class="py-0">
        <slot />
    </UMain>
</template>
